import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import get from "lodash/get";
import { useFormContext, Controller } from "react-hook-form";

const SelectField = ({ name, label, ...props }) => {
	const { control, formState } = useFormContext();
	const { errors } = formState;
	const error = get(errors, name);

	return (
		<>
			<Controller
				name={name}
				control={control}
				render={({ field }) => (
					<FormControl
						error={Boolean(error)}
						className={props.className}
						variant={props.variant}
						fullWidth={props.fullWidth}
						required={props.required}
					>
						{label && <InputLabel htmlFor={name}>{label}</InputLabel>}
						<Select {...props} {...field} />
						{Boolean(error) && (
							<FormHelperText>{error?.message}</FormHelperText>
						)}
					</FormControl>
				)}
			/>
		</>
	);
};

SelectField.propTypes = {
	label: PropTypes.string.isRequired,
	autoFocus: PropTypes.bool,
	fullWidth: PropTypes.bool,
	variant: PropTypes.string,
	required: PropTypes.bool,
};
export default SelectField;
